import React, { useCallback, useEffect, useState } from "react";
import { Box, Typography, Chip } from "@mui/material";
import TransTable from "../common/TransTable";
import { PageTitle } from "../common/PageTitle";
import Axios from "axios";
import { base_url } from "../backendurl/url";
import { Notification } from "../common/Notification";
import { Config } from "../../utils/commonFuctions/Token";
import { RefreshToken } from "../../utils/commonFuctions/RefreshToken";
import { utcTimetoLocalTimeWithzone } from "../common/TransForm/Localdateformater";
import { setUsers } from "../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Iconify from "../common/Iconify";
import { hasWritePermission } from "../common/PermissionUtility";

function UserLogs() {
    const dispatch = useDispatch();
    const { users } = useSelector((state) => state);

    // State management
    const [loading, setLoading] = useState(false);
    const [userLogsData, setUserLogsData] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [notification, setNotification] = useState(false);

    // Server-side pagination states
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [sortOrder, setSortOrder] = useState('');
    const [sortBy, setSortBy] = useState('');
    const [searchQuery, setSearchQuery] = useState('');

    // Excel download states
    const [allExcelData, setAllExcelData] = useState([]);

    // NEW: State to track if search has been performed
    const [hasSearched, setHasSearched] = useState(false);
     const canWriteReports = hasWritePermission('serverreport');
       // Format date helper function
    // const formatDate = (dateString) => {
    //     if (!dateString) return 'N/A';
    //     const date = new Date(dateString);
    //     return date.toLocaleTimeString();
    // };
    // formatDate.js
 const formatDate = (dateString, timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleTimeString('en-US', {
        timeZone, // use detected timezone
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true // change to false for 24-hour format
    });
};


    // File Extension and Type for excel download
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    // Action type colors mapping
    const getActionColor = (action) => {
        const actionColors = {
            'LOGIN': { color: '#219653', backgroundColor: '#21965333' },
            'LOGOUT': { color: '#6B7280', backgroundColor: '#F3F4F6' },
            'CREATE': { color: '#3B82F6', backgroundColor: '#DBEAFE' },
            'UPDATE': { color: '#F59E0B', backgroundColor: '#FEF3C7' },
            'DELETE': { color: '#EF4444', backgroundColor: '#FEE2E2' },
            'VIEW': { color: '#8B5CF6', backgroundColor: '#EDE9FE' },
            'DOWNLOAD': { color: '#10B981', backgroundColor: '#D1FAE5' },
            'UPLOAD': { color: '#F97316', backgroundColor: '#FED7AA' },
            'PAYMENT': { color: '#EC4899', backgroundColor: '#FCE7F3' },
            'REGISTRATION': { color: '#06B6D4', backgroundColor: '#CFFAFE' },
        };

        const normalizedAction = action?.toUpperCase();
        return actionColors[normalizedAction] || { color: '#6B7280', backgroundColor: '#F3F4F6' };
    };

    // Table columns configuration
    const userLogsTableColumns = () => {
        return [
            {
                key: "username",
                label: "User Name",
                align: "center",
                fontSize: "14px",
                width: "60px"
            },
            {
                key: "date",
                label: "Date",
                align: "left",
                valueRenderer: (data) => {
                    let date = utcTimetoLocalTimeWithzone(data["date"]);
                    const [datePart, timePart] = date.split(", ");
                    return <Typography sx={{ width: "150px" }}>{datePart}</Typography>;
                },
            },
            { 
                key: "created_at", 
                label: "Time Stamp", 
                align: "left",
                fontSize: "14px",
                columnStyle: { minWidth: "120px", width: "120px" },
                valueRenderer: (data) => {
                    return formatDate(data.created_at);
                }
            },
            {
                key: "action",
                label: "Action",
                align: "center",
                fontSize: "14px",
                valueRenderer: (data) => {
                    const rawAction = data?.action || "-";
                  //  const formattedAction = rawAction.replace(/_/g, " ");
                  const formattedAction =
                        rawAction === "POST_JOINPOT"
                            ? "JOINED ROUND"
                            : rawAction.replace(/_/g, " "); // fallback formatting
                    const actionStyle = getActionColor(rawAction);
                    return (
                        <Chip
                            label={formattedAction}
                            size="small"
                            sx={{
                                backgroundColor: actionStyle.backgroundColor,
                                color: actionStyle.color,
                                fontWeight: 500,
                                fontSize: '12px'
                            }}
                        />
                    );
                },
            },
            {
                key: "round_id",
                label: "Round ID",
                align: "left",
                fontSize: "15px",
                valueRenderer: (data) => {
                    if (data["round_id"] == null) {
                        return <Typography> -</Typography>
                    } else {
                        return <Typography>{data['round_id']}</Typography>
                    }
                },
            },
            {
                key: "round_name",
                label: "RoundName",
                align: "left",
                fontSize: "15px",
                valueRenderer: (data) => {
                    if (data["round_name"] == null) {
                        return <Typography> -</Typography>
                    } else {
                        return <Typography>{data['round_name']}</Typography>
                    }
                },
            },
              {
                key: "predicted_team",
                label: "Team Name",
                align: "left",
                fontSize: "15px",
                valueRenderer: (data) => {
                    if (data["predicted_team"] == null) {
                        return <Typography> -</Typography>
                    } else {
                        return <Typography>{data['predicted_team']}</Typography>
                    }
                },
            },
            {
                key: "pick_id",
                label: "Pick ID",
                align: "left",
                fontSize: "15px",
                valueRenderer: (data) => {
                    if (data["pick_id"] == null) {
                        return <Typography> -</Typography>
                    } else {
                        return <Typography>{data['pick_id']}</Typography>
                    }
                },
            },
            {
                key: "no_of_tokens",
                label: "Number of Tokens",
                align: "left",
                fontSize: "15px",
                valueRenderer: (data) => {
                    if (data["no_of_tokens"] == null) {
                        return <Typography> -</Typography>
                    } else {
                        return <Typography>{data['no_of_tokens']}</Typography>
                    }
                },
            },
            {
                key: "voted",
                label: "Voted",
                align: "left",
                fontSize: "15px",
                valueRenderer: (data) => {
                    if (data["voted"] == null) {
                        return <Typography> -</Typography>
                    } else {
                        return <Typography>{data['voted']}</Typography>
                    }
                },
            },
            
            {
                key: "status_display",
                label: "Status",
                align: "center",
                fontSize: "14px",
                valueRenderer: (data) => {
                    const status = data?.status_display || data?.status_display || "SUCCESS";
                    const isSuccess = status.toUpperCase() === "SUCCESS";

                    return (
                        <Chip
                            label={status}
                            size="small"
                            sx={{
                                backgroundColor: isSuccess ? "#21965333" : "#FFE8E1",
                                color: isSuccess ? "#219653" : "#E42C2C",
                                fontWeight: 500,
                                fontSize: '12px'
                            }}
                        />
                    );
                },
            }
        ];
    };

    // Excel table columns (simplified for export)
    const userLogsExcelTableColumns = () => {
        return [
            {
                key: "username",
                label: "User Name",
                valueRenderer: (data) => data?.username || data?.username || "-",
            },
            {
                key: "date",
                label: "Date",
                valueRenderer: (data) => {
                    const timestamp = data?.date || data?.date || data?.date;
                    return timestamp ? utcTimetoLocalTimeWithzone(timestamp) : "-";
                },
            },
            {
                key: "created_at",
                label: "Time Stamp",
                valueRenderer: (data) => {
                    const timestamp = data?.created_at;
                    return timestamp ? formatDate(timestamp) : "-";
                },
            },
            {
                key: "action",
                label: "Action",
                valueRenderer: (data) => {
                    const rawAction = data?.action || "-";
                    // const formattedAction = rawAction.replace(/_/g, " ");
                      const formattedAction =
                        rawAction === "POST_JOINPOT"
                            ? "JOINED ROUND"
                            : rawAction.replace(/_/g, " "); // fallback formatting
                    return formattedAction;
                }
            },
            {
                key: "round_id",
                label: "Round ID",
                valueRenderer: (data) => data?.round_id || data?.round_id || "-",
            },
            {
                key: "round_name",
                label: "Round Name",
                valueRenderer: (data) => data?.round_name || data?.round_name || "-",
            },
            {
                key: "predicted_team",
                label: "Team Name",
                valueRenderer: (data) => data?.predicted_team || data?.predicted_team || "-",
            },
            {
                key: "pick_id",
                label: "Pick ID",
                valueRenderer: (data) => data?.pick_id || data?.pick_id || "-",
            },
            {
                key: "no_of_tokens",
                label: "Number Of Tokens",
                valueRenderer: (data) => data?.no_of_tokens || data?.no_of_tokens || "-",
            },
            {
                key: "voted",
                label: "Voted",
                valueRenderer: (data) => data?.voted || data?.voted || "-",
            },
            {
                key: "status_display",
                label: "Status",
                valueRenderer: (data) => data?.status_display || data?.status_display || "SUCCESS",
            }
        ];
    };

    // Fetch user logs data - MODIFIED to require username search
    const getUserLogs = useCallback(async (page = 1, limit = 10, orderBy = '', order = '', search = '') => {
        // NEW: Don't fetch data if no search query is provided
        if (!search || search.trim() === '') {
            dispatch(setUsers([]));
            setUserLogsData([]);
            setTotalCount(0);
            setHasSearched(false);
            return;
        }

        dispatch(setUsers([]));
        try {
            setLoading(true);
            setHasSearched(true); // NEW: Mark that a search has been performed

            // Build query parameters
            let queryParams = `page=${page}&limit=${limit}`;

            // Add sorting parameters if provided
            if (orderBy && order) {
                queryParams += `&sort_by=${orderBy}&order=${order !== 'desc' ? 'desc' : 'asc'}`;
            }

            // Add search parameter - this is now required
            queryParams += `&search=${encodeURIComponent(search.trim())}`;

            console.log(`${base_url}/api/dashboard/admin-dashboard/user-logs/?${queryParams}`, "User Logs URL");

            const response = await Axios.get(
                `${base_url}/api/dashboard/admin-dashboard/user-logs/?${queryParams}`,
                Config
            );

            console.log(response, "User Logs Response");

            if (response?.status === 200) {
                let startIndex = (page - 1) * limit + 1;
                let data = response?.data?.results || response?.data?.data || response?.data || [];

                // Add serial numbers
                data = data.map((item, index) => ({
                    ...item,
                    serial_no: startIndex + index
                }));

                dispatch(setUsers(data));
                setUserLogsData(data);
                setTotalCount(response?.data?.count || response?.data?.total || data.length);
            }

            setLoading(false);
        } catch (error) {
            console.log(error, "User Logs Error");
            setLoading(false);
            setHasSearched(true); // NEW: Still mark as searched even on error
            RefreshToken(error, setErrorMessage, setNotification);
        }
    }, [dispatch]);

    // Handle pagination change from TransTable
    const handlePageChange = useCallback((page, rowsPerPage) => {
        setCurrentPage(page);
        setRowsPerPage(rowsPerPage);
        getUserLogs(page + 1, rowsPerPage, sortBy, sortOrder, searchQuery);
    }, [sortBy, sortOrder, searchQuery, getUserLogs]);

    // Handle sorting change from TransTable
    const handleSortChange = useCallback((orderBy, order) => {
        setSortBy(orderBy);
        setSortOrder(order);
        setCurrentPage(0);
        getUserLogs(1, rowsPerPage, orderBy, order, searchQuery);
    }, [rowsPerPage, searchQuery, getUserLogs]);

    // Handle search from TransTable - MODIFIED
    const handleSearch = useCallback((searchValue) => {
        setSearchQuery(searchValue);
        setCurrentPage(0);
        
        // NEW: Reset hasSearched when search is cleared
        if (!searchValue || searchValue.trim() === '') {
            setHasSearched(false);
            setUserLogsData([]);
            setTotalCount(0);
            dispatch(setUsers([]));
            return;
        }
        
        getUserLogs(1, rowsPerPage, sortBy, sortOrder, searchValue);
    }, [rowsPerPage, sortBy, sortOrder, getUserLogs, dispatch]);

    // Get all user logs for Excel download - MODIFIED to require search
    const getAllUserLogsForExcel = async () => {
        // NEW: Don't allow Excel download if no search has been performed
        if (!hasSearched || !searchQuery || searchQuery.trim() === '') {
            return [];
        }

        try {
            setLoading(true);
            const response = await Axios.get(
                `${base_url}/api/dashboard/admin-dashboard/all-user-logs/?search=${encodeURIComponent(searchQuery.trim())}`,
                Config
            );

            if (response?.status === 200) {
                setLoading(false);
                return response?.data?.results || response?.data?.data || response?.data || [];
            }
            setLoading(false);
            return [];
        } catch (error) {
            setLoading(false);
            console.log("Excel download error, falling back to current data");
            return userLogsData; // Fallback to current displayed data
        }
    };
console.log(searchQuery, "searchQuery")
    // Handle Excel download - MODIFIED
    // const handleExcelDownload = async () => {
    //     // NEW: Don't allow Excel download if no search has been performed
    //     if (!hasSearched || !searchQuery || searchQuery.trim() === '') {
    //         return;
    //     }

    //     try {
    //         setLoading(true);
    //         const allLogsData = await getAllUserLogsForExcel();

    //         if (allLogsData.length > 0  && searchQuery.trim() === '') {
    //             setAllExcelData(allLogsData);
    //             setTimeout(() => {
    //                 setAllExcelData(allLogsData);
    //             }, 100);
    //         } else {
    //             setAllExcelData(userLogsData);
    //         }
    //     } catch (error) {
    //         console.error('Error downloading Excel:', error);
    //         setAllExcelData(userLogsData);
    //     } finally {
    //         setLoading(false);
    //     }
    // };
    const handleExcelDownload = async () => {
    // Prevent download if no search performed
    if (!hasSearched || !searchQuery || searchQuery.trim() === '') {
        return;
    }

    try {
        setLoading(true);
        const allLogsData = await getAllUserLogsForExcel();

        // Prepare the dataset for Excel
        const dataset = allLogsData.length > 0 ? allLogsData : userLogsData;

        // Convert data to worksheet
        const worksheet = XLSX.utils.json_to_sheet(
            dataset.map(row => {
                let formattedRow = {};
                userLogsExcelTableColumns().forEach(col => {
                    formattedRow[col.label] = col.valueRenderer(row);
                });
                return formattedRow;
            })
        );

        // Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "UserLogs");

        // Export
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, `UserLogs_${Date.now()}${fileExtension}`);
    } catch (error) {
        console.error('Error downloading Excel:', error);
    } finally {
        setLoading(false);
    }
};


    // REMOVED: Initialize component - no longer fetch data on mount
    // useEffect(() => {
    //     getUserLogs();
    // }, []);

    // NEW: Custom search message component
    const CustomNoDataMessage = () => {
        if (!hasSearched) {
            return (
                <Box 
                    sx={{ 
                        display: 'flex', 
                        justifyContent: 'center', 
                        alignItems: 'center', 
                        minHeight: '300px',
                        flexDirection: 'column',
                        gap: 2
                    }}
                >
                    <Typography 
                        variant="h6" 
                        sx={{ 
                            color: '#6B7280',
                            fontWeight: 500
                        }}
                    >
                        Please enter the username to get the user logs
                    </Typography>
                    <Typography 
                        variant="body2" 
                        sx={{ 
                            color: '#9CA3AF',
                            textAlign: 'center'
                        }}
                    >
                        Use the search box above to search for a specific user's activity logs
                    </Typography>
                </Box>
            );
        }
        return null;
    };

    return (
        <Box sx={{ width: "100%", typography: "body1" }}>
            {/* NEW: Show custom message when no search has been performed */}
            {!hasSearched ? (
                <Box>
                    {/* Page Title */}
                    <Box sx={{ mb: 0, px: 6, pt: 3, pb: 0 }}>
                        <PageTitle pageTitle="User Activity Logs" />
                    </Box>
                    
                    {/* Search Box */}
                    <Box sx={{ display: "flex", px: 6, mb: 3 }}>
                        <input
                            type="text"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    handleSearch(searchQuery);
                                }
                            }}
                            placeholder="Enter the username to get the user logs details"
                            style={{
                                width: "90%",
                                padding: "12px 16px",
                                border: "1px solid #D1D5DB",
                                borderRadius: "4px",
                                fontSize: "14px",
                                outline: "none"
                            }}
                        />
                        <Box
                            onClick={() => handleSearch(searchQuery)}
                            sx={{
                                display: "flex",
                                backgroundColor: "#3C50E0",
                                ml: 1,
                                color: "#EFF4FB",
                                borderRadius: '3px',
                                justifyContent: "space-between",
                                px: 2,
                                width: '134px',
                                alignItems: "center",
                                cursor: 'pointer'
                            }}
                        >
                            <Typography sx={{ mr: 4 }}>Search</Typography>
                            <Iconify
                                    icon="eva:search-fill"
                                    sx={{ color: "#fff", height: "18px" }}
                                  />
                        </Box>
                    </Box>
                    
                    {/* Custom No Data Message */}
                    <CustomNoDataMessage />
                </Box>
            ) : (
                // Show TransTable only after search has been performed
                <TransTable
                    pageTitle="User Activity Logs"
                    excelColumns={userLogsExcelTableColumns()}
                    //showAddBtn={canWriteReports}
                    isExcel={canWriteReports}
                    showSearch={true}
                    checkbox={false}
                    columns={userLogsTableColumns()}
                    rows={userLogsData}
                    showAddBtn={false}
                    filter_keys={["username", "email", "action", "description"]}
                    isLoading={loading}
                    // Server-side pagination props
                    serverSide={true}
                    totalCount={totalCount}
                    currentPage={currentPage}
                    rowsPerPage={rowsPerPage}
                    onPageChange={handlePageChange}
                    onSortChange={handleSortChange}
                    // Search functionality - MODIFIED placeholder
                    onSearch={handleSearch}
                    searchQuery={searchQuery}
                    // NEW: Custom placeholder for search
                    searchPlaceholder="Enter the username to get the user logs details"
                    // Excel download functionality
                    customExcelData={allExcelData}
                    onExcelDownload={handleExcelDownload}
                />
            )}

            <Notification
                message={errorMessage}
                setopen={setNotification}
                type={"error"}
                show={notification}
            />
        </Box>
    );
}

export default UserLogs;